<section class="personal-data-main-section h-100 d-flex align-items-center justify-content-center">
    <div class="form-row">
        <div class="form-group">
            <div class="d-flex d-md-none">
                <p [innerHTML]="'pt.edp.edponline.personal.data.validation.mobile.helper' | translate"></p>
            </div>
            <form [formGroup]="form">
                <label class="custom-input-label" for="nifInput">
                    {{ "pt.edp.edponline.personal.data.validation.input.label" | translate }}
                </label>
                <input class="form-control custom-input" type="number" name="nifInput" formControlName="nif" />
                <ng-container *ngIf="!form.valid && nifValue !== null">
                    <span class="custom-input-error-message">
                        {{ "pt.edp.edponline.personal.data.validation.input.error.message" | translate }}
                    </span>
                </ng-container>
                <ng-container *ngIf="nifNotFound">
                    <span class="custom-input-error-message">
                        {{ "pt.edp.edponline.personal.data.validation.nif.not.found.error.message" | translate }}
                    </span>
                </ng-container>
                <div class="d-flex justify-content-center custom-buttom-wrapper">
                    <button
                        class="custom-buttom"
                        [ngClass]="{ disabled: !form.valid }"
                        [disabled]="!form.valid"
                        (click)="onSubmitClick(captchaRef)"
                    >
                        <span class="d-none d-md-flex">{{ "pt.edp.edponline.personal.data.validation.desktop.button" | translate }}</span>
                        <span class="d-flex d-md-none">{{ "pt.edp.edponline.personal.data.validation.mobile.button" | translate }}</span>
                    </button>
                </div>
                <div class="recaptcha-wrapper">
                    <re-captcha #captchaRef="reCaptcha" (resolved)="resolved($event)" size="invisible"></re-captcha>
                </div>
            </form>
        </div>
    </div>
</section>
